import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4643yu7ag8: FaireBrandEntity = {
  token: "b_4643yu7ag8",
  type: "brand",
  name: "Mad Candle Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/2f9ad9996b652fd3af66da42acfde838017700104021aeeaf161d5acb3608ae0.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/71dd5866dbd1578c258c53dbf8bcd882c29cf209601bb9d1d06709544692dd23.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/2f9ad9996b652fd3af66da42acfde838017700104021aeeaf161d5acb3608ae0.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/71dd5866dbd1578c258c53dbf8bcd882c29cf209601bb9d1d06709544692dd23.jpeg",
  location: "Eugene , OR, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 37,
  isTopShop: true,
  isInsider: true,
  description:
    "Mad Candle Co. is a woman-owned home fragrance brand based in Eugene, Oregon, founded by Madeline Jane.\n\nAfter struggling to find non-toxic, vegan soy candles that met her standards for quality and sustainability, Madeline started making her own in 2018. What began as a hobby quickly turned into a mission: to create clean-burning, beautifully scented candles made with ingredients customers can trust.\n\nOfficially launched in May 2024, Mad Candle Co. offers a thoughtfully curated line of small-batch candles made with pure soy wax, phthalate-free fragrance oils, and FSC-certified wood wicks. Every candle is hand-poured to order, ensuring freshness and attention to detail in every batch.\n\nMad candles are made for customers who value eco-friendly, non-toxic, and premium-quality products. When you light a Mad Candle, you’re not just filling the room with a beautiful scent—you’re creating an atmosphere that’s warm, inviting, and aligned with values that matter.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:55.115Z",
    importedBy: "entity-db-cli",
  },
};
